// extracted by mini-css-extract-plugin
module.exports = {"menu-button":"MenuButton-module__menu-button___2HYht","menu-icon":"MenuButton-module__menu-icon___2XyNn","nav-badge":"MenuButton-module__nav-badge___11615"};